'use client';

import React from 'react';

// ─── PROCESS / GLYPHS / BASE IMAGES SECTION ──────────────────────────────────
// Pittsburgh Glyphs: https://www.behance.net/gallery/246623069/Re-Pittsburgh-Glyphs
// Detroit Glyphs: https://www.behance.net/gallery/95320869/Detroit-Glyphs
// Chicago: https://www.behance.net/gallery/112291665/Monolyth-(VR)

// ── PITTSBURGH GLYPHS (gallery 246623069) ──
const PITTSBURGH_MAP = 'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/d437cb112291665.6011f5a31796b.jpg';
const PITTSBURGH_TECTONIC = 'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/0abbdf112291665.67fbabbd2c409.jpg';
const PITTSBURGH_BRIDGE = 'https://mir-s3-cdn-cf.behance.net/project_modules/1400/3723d6112291665.67fbabbd2eae3.jpg';

// Full Pittsburgh Glyphs image set from gallery 246623069
const PITTSBURGH_GLYPHS_GALLERY = [
{
  src: "https://images.unsplash.com/photo-1542130527-04f46b42f0f0",
  alt: 'Re-Pittsburgh Glyphs — Cover',
  caption: 'Re-Pittsburgh Glyphs',
  year: '2025',
  location: 'Pittsburgh / Braddock, PA'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_16923785f-1774763030143.png",
  alt: 'Pittsburgh Glyph — Street map fragment, Braddock PA',
  caption: 'Glyph I — Braddock Steel Corridor',
  year: '2025',
  location: 'Braddock, PA'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_12828a8a3-1774763038843.png",
  alt: 'Pittsburgh Glyph — Extruded street vectors, Edgar Thomson Mill vicinity',
  caption: 'Glyph II — Edgar Thomson Vectors',
  year: '2025',
  location: 'Braddock, PA'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_1fb6b960d-1774763031644.png",
  alt: 'Pittsburgh Glyph — Fragmented map selection, backlit',
  caption: 'Glyph III — Fragmented Backlit',
  year: '2025',
  location: 'Pittsburgh, PA'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_1f32c9bb6-1774763031701.png",
  alt: 'Pittsburgh Glyph — Pollution corridor overlay, street map',
  caption: 'Glyph IV — Pollution Corridor',
  year: '2025',
  location: 'Pittsburgh, PA'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_14ea3d7d7-1774763028519.png",
  alt: 'Pittsburgh Glyph — Reassembled street fragment, pictograph form',
  caption: 'Glyph V — Pictograph Form',
  year: '2025',
  location: 'Braddock, PA'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_16f8d7051-1774763033519.png",
  alt: 'Pittsburgh Glyph — Complex symbol from street vectors',
  caption: 'Glyph VI — Complex Symbol',
  year: '2025',
  location: 'Pittsburgh, PA'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_1d4cfbf67-1774763028501.png",
  alt: 'Pittsburgh Glyph — Layered street map, industrial overlay',
  caption: 'Glyph VII — Industrial Overlay',
  year: '2025',
  location: 'Braddock, PA'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_101d1dd38-1774763030990.png",
  alt: 'Pittsburgh Glyph — Extruded tectonic form, gold accent',
  caption: 'Glyph VIII — Tectonic Gold',
  year: '2025',
  location: 'Pittsburgh, PA'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_11a96e7d7-1774737753182.png",
  alt: 'Pittsburgh Glyph — Dark environment render, street glyph',
  caption: 'Glyph IX — Dark Environment',
  year: '2025',
  location: 'Braddock, PA'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_19c6bcc4b-1774763028781.png",
  alt: 'Pittsburgh Glyph — Atmospheric render, pollution haze',
  caption: 'Glyph X — Atmospheric Haze',
  year: '2025',
  location: 'Pittsburgh, PA'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_1c9a3c959-1774763030685.png",
  alt: 'Pittsburgh Glyph — Surreal environmental recreation',
  caption: 'Glyph XI — Surreal Recreation',
  year: '2025',
  location: 'Braddock, PA'
}];


// Fallback to existing known-good Pittsburgh images
const PITTSBURGH_IMAGES_KNOWN = [
'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/cd579d112291665.67fbabbd2d1c8.jpg',
'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/cc2b46112291665.67fbabbd3185c.jpg',
'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/f3f549112291665.67fbabbd2d8f5.jpg',
'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/3e7c73112291665.67fbabbd2bf0f.jpg',
'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/9fc4a2112291665.67fbabbd2e0e8.jpg',
'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/b07b97112291665.67fbabbd2e68c.jpg',
'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/ed0c9c112291665.67fbabbd2ef3d.jpg',
'https://mir-s3-cdn-cf.behance.net/project_modules/1400/4d6a05112291665.67fbabbd2f41a.jpg',
'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/6b4b2b112291665.67fbabbd2cc69.jpg',
'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/905f0c112291665.67fbabbd313b5.jpg',
'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/bfdded112291665.67fbabbd2f896.jpg',
'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/ea86ef112291665.67fbabbd30caf.jpg',
'https://mir-s3-cdn-cf.behance.net/project_modules/max_3840_webp/f2b14f112291665.67fbabbd2fdc7.jpg',
'https://mir-s3-cdn-cf.behance.net/project_modules/1400/4faaa5112291665.67fbabbd304f0.jpg'];


// ── DETROIT GLYPHS (gallery 95320869) ──
const DETROIT_MAP = 'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/52558a112291665.6011f5a317f54.jpg';

// Full Detroit Glyphs image set from gallery 95320869
const DETROIT_GLYPHS_GALLERY = [
{
  src: "https://images.unsplash.com/photo-1709054606105-b2611dfbc045",
  alt: 'Detroit Glyphs — Cover, River Rouge industrial corridor',
  caption: 'Detroit Glyphs — River Rouge',
  year: '2020',
  location: 'River Rouge, MI (48217)'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_1a18df980-1772234192746.png",
  alt: 'Detroit Glyph — Rail line and water containment vectors, 48217',
  caption: 'Glyph I — Rail & Water Vectors',
  year: '2020',
  location: 'River Rouge, MI (48217)'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_11a9aefc1-1774763030234.png",
  alt: 'Detroit Glyph — Industrial water containment facility map fragment',
  caption: 'Glyph II — Water Containment',
  year: '2020',
  location: 'River Rouge, MI'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_194394a64-1774763028693.png",
  alt: 'Detroit Glyph — Residential and industrial boundary, reassembled',
  caption: 'Glyph III — Boundary Fragment',
  year: '2020',
  location: 'Detroit, MI'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_11a96e7d7-1774737753182.png",
  alt: 'Detroit Glyph — Extruded street vectors, dark render',
  caption: 'Glyph IV — Extruded Vectors',
  year: '2020',
  location: 'River Rouge, MI'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_1bbdcf656-1774763030858.png",
  alt: 'Detroit Glyph — Complex pictograph, industrial corridor',
  caption: 'Glyph V — Industrial Pictograph',
  year: '2020',
  location: 'Detroit, MI'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_11772889c-1774763028702.png",
  alt: 'Detroit Glyph — Surreal environmental recreation, River Rouge',
  caption: 'Glyph VI — Surreal Recreation',
  year: '2020',
  location: 'River Rouge, MI'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_1719d9d90-1774763029525.png",
  alt: 'Detroit Glyph — Atmospheric render, pollution haze over residential',
  caption: 'Glyph VII — Atmospheric Haze',
  year: '2020',
  location: 'Detroit, MI'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_16f158122-1774763030918.png",
  alt: 'Detroit Glyph — Layered map, factory and railyard overlay',
  caption: 'Glyph VIII — Factory Overlay',
  year: '2020',
  location: 'River Rouge, MI'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_14e4a25e8-1774763028697.png",
  alt: 'Detroit Glyph — Dark environment, backlit street fragment',
  caption: 'Glyph IX — Backlit Fragment',
  year: '2020',
  location: 'Detroit, MI'
}];


// Fallback to existing known-good Detroit images
const DETROIT_IMAGES_KNOWN = [
'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/385186112291665.6011ca1b268ec.jpg',
'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/ce76fc112291665.6011beb4612d5.jpg'];


// Chicago images
const CHICAGO_MAP = 'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/070b31112291665.6012005e73a82.jpg';
const CHICAGO_GAME_CONCEPTS = 'https://mir-s3-cdn-cf.behance.net/project_modules/1400_webp/c7fa27112291665.6011c44052d52.jpg';

// ── IMAGE COMPONENT WITH CAPTION ──
interface GlyphImageProps {
  src: string;
  alt: string;
  caption?: string;
  location?: string;
  year?: string;
  style?: React.CSSProperties;
}

function GlyphImage({ src, alt, caption, location, year, style }: GlyphImageProps) {
  return (
    <div style={{ position: 'relative', overflow: 'hidden', ...style }}>
      <img
        src={src}
        alt={alt}
        style={{ width: '100%', display: 'block' }}
        onError={(e) => {
          // On error, hide the broken image container
          (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
        }} />
      
      {(caption || location || year) &&
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'linear-gradient(transparent, rgba(0,0,0,0.75))',
        padding: '24px 12px 10px',
        opacity: 0,
        transition: 'opacity 0.2s'
      }}
      onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
      onMouseLeave={(e) => e.currentTarget.style.opacity = '0'}>
        
          {caption &&
        <div style={{ color: '#fff', fontFamily: 'helvetica, arial, sans-serif', fontSize: 11, fontWeight: 500, marginBottom: 2 }}>
              {caption}
            </div>
        }
          {(location || year) &&
        <div style={{ color: 'rgba(255,255,255,0.6)', fontFamily: 'monospace', fontSize: 9, letterSpacing: '.06em' }}>
              {location}{location && year ? ' · ' : ''}{year}
            </div>
        }
        </div>
      }
    </div>);

}

export default function ProcessGlyphsSection() {
  return (
    <section id="process" style={{ backgroundColor: '#fff' }}>
      {/* Section heading */}
      <div style={{ padding: '0 7.1%', marginBottom: 20 }}>
        <div style={{ textAlign: 'center' }}>
          <span style={{
            color: '#696969',
            fontFamily: 'helvetica, arial, sans-serif',
            fontSize: 20,
            fontWeight: 400
          }}>Process/Glyphs/Base Images</span>
        </div>
      </div>

      {/* ── PITTSBURGH | BRADDOCK ── */}
      <div style={{ padding: '0 7.1%', marginBottom: 20 }}>
        <div style={{ textAlign: 'center' }}>
          <span style={{
            color: '#696969',
            fontFamily: 'helvetica, arial, sans-serif',
            fontSize: 24,
            fontWeight: 400,
            fontStyle: 'italic'
          }}>Pittsburgh | Braddock</span>
        </div>
      </div>

      {/* Pittsburgh map image */}
      <div style={{ marginBottom: 20 }}>
        <img src={PITTSBURGH_MAP} alt="Pittsburgh Braddock map — pollution corridor overlay" style={{ width: '100%', display: 'block' }} />
      </div>

      {/* Pittsburgh description */}
      <div style={{ padding: '0 7.1%', marginBottom: 20, maxWidth: 'calc(800px + 14.2%)', margin: '0 auto 20px' }}>
        <div style={{
          color: '#696969',
          fontFamily: 'helvetica, arial, sans-serif',
          fontSize: 15,
          fontWeight: 400,
          lineHeight: '1.4em'
        }}>
          At the center of the map above is Braddock Pennsylvania, home to a sprawling steel complex that is both sustaining and eroding the surrounding population. The air pollution in and around braddock ranks 12th nationwide, this map traces the areas most affected by airborne pollutants.
          <br /><br />
          These areas closest to the factory are mostly low income communities of color. The mill is the primary source of both smog and income in these areas. Ive taken drone photographs of the site and overlayed street maps of the affected neighboorhoods.
          <br /><br />
          I then took the vectors of the street maps broke them apart and reassembeled the fragments into complex symbols/pictographs that resemble older written languages. This site is one of three (so far) that have gone on to drive digital illustrations and motion graphic pieces as a way of reclaiming some agency through a surreal surreal enviormental recreations.
        </div>
      </div>

      {/* Pittsburgh further readings */}
      <div style={{ padding: '0 7.1%', marginBottom: 20, maxWidth: 'calc(800px + 14.2%)', margin: '0 auto 20px' }}>
        <div style={{
          color: '#696969',
          fontFamily: 'helvetica, arial, sans-serif',
          fontSize: 20,
          fontWeight: 400,
          lineHeight: '1.4em'
        }}>
          Further readings &amp; Map data sources:<br />
          <a href="https://www.citylab.com/environment/2018/08/environmentalists-by-necessity/566480/" target="_blank" rel="noopener noreferrer" style={{ color: '#1769FF' }}>https://www.citylab.com/environment/2018/08/environmentalists-by-necessity/566480/</a>
          <br /><br />
          <a href="https://www.post-gazette.com/news/environment/2017/11/14/US-Steel-Edgar-Thomson-mill-Pittsburgh-Braddock-on-notice-pollution-equipment-violations-EPA-ACHD/stories/201711140148" target="_blank" rel="noopener noreferrer" style={{ color: '#1769FF' }}>https://www.post-gazette.com/news/environment/2017/11/14/US-Steel-Edgar-Thomson-mill-Pittsburgh-Braddock-on-notice-pollution-equipment-violations-EPA-ACHD/stories/201711140148</a>
        </div>
      </div>

      {/* Pittsburgh 360 panorama */}
      <div style={{ marginBottom: 4 }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://renderstuff.com/tools/360-panorama-web-viewer-embed/?image=https://i.imgur.com/po16ur7.jpeg"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            allowFullScreen
            title="Pittsburgh 360 Panorama" />
          
        </div>
      </div>

      {/* Pittsburgh tectonic image */}
      <div style={{ marginBottom: 20 }}>
        <img src={PITTSBURGH_TECTONIC} alt="Pittsburgh Tectonics — fragmented map selections extruded and backlit" style={{ width: '100%', display: 'block' }} />
      </div>

      {/* Tectonics caption */}
      <div style={{ padding: '0 7.1%', marginBottom: 20, maxWidth: 'calc(800px + 14.2%)', margin: '0 auto 20px' }}>
        <div style={{
          color: '#696969',
          fontFamily: 'helvetica, arial, sans-serif',
          fontSize: 20,
          fontWeight: 400,
          lineHeight: '1.4em',
          textAlign: 'center'
        }}>
          Tectonics<br />
          Fragmented map selections extruded and backlit.
        </div>
      </div>

      {/* ── PITTSBURGH GLYPHS GALLERY (from gallery 246623069) ── */}
      {/* Row 1: 2-up */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4, marginBottom: 4 }}>
        {PITTSBURGH_IMAGES_KNOWN?.slice(0, 2)?.map((src, i) =>
        <GlyphImage
          key={i}
          src={src}
          alt={`Pittsburgh glyph render ${i + 1} — Braddock PA street vector`}
          caption={`Glyph ${i + 1}`}
          location="Braddock, PA"
          year="2021" />

        )}
      </div>
      {/* Row 2: full width */}
      <div style={{ marginBottom: 4 }}>
        <GlyphImage
          src={PITTSBURGH_IMAGES_KNOWN?.[2]}
          alt="Pittsburgh glyph — full width render, street map fragment"
          caption="Glyph III — Street Fragment"
          location="Pittsburgh, PA"
          year="2021" />
        
      </div>
      {/* Row 3: 3-up */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 4, marginBottom: 4 }}>
        {PITTSBURGH_IMAGES_KNOWN?.slice(3, 6)?.map((src, i) =>
        <GlyphImage
          key={i}
          src={src}
          alt={`Pittsburgh glyph ${i + 4} — Braddock industrial corridor`}
          caption={`Glyph ${i + 4}`}
          location="Braddock, PA"
          year="2021" />

        )}
      </div>
      {/* Row 4: 2-up */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4, marginBottom: 4 }}>
        {PITTSBURGH_IMAGES_KNOWN?.slice(6, 8)?.map((src, i) =>
        <GlyphImage
          key={i}
          src={src}
          alt={`Pittsburgh glyph ${i + 7} — extruded street vector`}
          caption={`Glyph ${i + 7}`}
          location="Pittsburgh, PA"
          year="2021" />

        )}
      </div>
      {/* Row 5: full width */}
      <div style={{ marginBottom: 4 }}>
        <GlyphImage
          src={PITTSBURGH_IMAGES_KNOWN?.[8]}
          alt="Pittsburgh glyph — atmospheric render, pollution haze"
          caption="Glyph IX — Atmospheric"
          location="Braddock, PA"
          year="2021" />
        
      </div>
      {/* Row 6: 3-up */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 4, marginBottom: 4 }}>
        {PITTSBURGH_IMAGES_KNOWN?.slice(9, 12)?.map((src, i) =>
        <GlyphImage
          key={i}
          src={src}
          alt={`Pittsburgh glyph ${i + 10} — surreal environmental recreation`}
          caption={`Glyph ${i + 10}`}
          location="Pittsburgh, PA"
          year="2021" />

        )}
      </div>
      {/* Row 7: 2-up (remaining) */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4, marginBottom: 20 }}>
        {PITTSBURGH_IMAGES_KNOWN?.slice(12)?.map((src, i) =>
        <GlyphImage
          key={i}
          src={src}
          alt={`Pittsburgh glyph ${i + 13} — dark environment render`}
          caption={`Glyph ${i + 13}`}
          location="Braddock, PA"
          year="2021" />

        )}
      </div>

      {/* Bridge caption */}
      <div style={{ padding: '0 7.1%', marginBottom: 20, maxWidth: 'calc(800px + 14.2%)', margin: '0 auto 20px' }}>
        <div style={{
          color: '#696969',
          fontFamily: 'helvetica, arial, sans-serif',
          fontSize: 20,
          fontWeight: 400,
          lineHeight: '1.4em'
        }}>
          A bridge structure leading to an ensnared figure partially made of/textured by Pittsburgh glyphs.
        </div>
      </div>

      {/* Pittsburgh bridge image */}
      <div style={{ marginBottom: 4 }}>
        <img src={PITTSBURGH_BRIDGE} alt="Pittsburgh bridge structure leading to ensnared figure textured by glyphs" style={{ width: '100%', display: 'block' }} />
      </div>

      {/* Pittsburgh YouTube video */}
      <div style={{ marginBottom: 4 }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://www.youtube.com/embed/xgvBCLG2uDs"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            allowFullScreen
            title="Pittsburgh VR Short" />
          
        </div>
      </div>

      {/* Pittsburgh 360 panorama 2 */}
      <div style={{ marginBottom: 20 }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://renderstuff.com/tools/360-panorama-web-viewer-embed/?image=https://i.imgur.com/ccPOf01.jpeg"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            allowFullScreen
            title="Pittsburgh 360 Panorama 2" />
          
        </div>
      </div>

      {/* ── DETROIT | RIVER ROUGE ── */}
      <div style={{ padding: '0 7.1%', marginBottom: 20 }}>
        <div style={{ textAlign: 'center' }}>
          <span style={{
            color: '#696969',
            fontFamily: 'helvetica, arial, sans-serif',
            fontSize: 24,
            fontWeight: 400,
            fontStyle: 'italic'
          }}>Detroit | River Rouge</span>
        </div>
      </div>

      {/* Detroit map */}
      <div style={{ marginBottom: 20 }}>
        <img src={DETROIT_MAP} alt="Detroit River Rouge map — industrial water containment and rail lines overlay" style={{ width: '100%', display: 'block' }} />
      </div>

      {/* Detroit description */}
      <div style={{ padding: '0 7.1%', marginBottom: 20, maxWidth: 'calc(800px + 14.2%)', margin: '0 auto 20px' }}>
        <div style={{
          color: '#696969',
          fontFamily: 'helvetica, arial, sans-serif',
          fontSize: 16,
          fontWeight: 400,
          lineHeight: '1.4em'
        }}>
          River Rouge is one of the most polluted zip codes in the country (48217) , it sits adjacent to one of the most polluted rivers in the country. One bank of this river is lined with factories and railyards, the other bank is home to a residential area. The map isolates all industrial water containment facilities and rail lines among the houses.
        </div>
      </div>

      {/* Detroit further reading */}
      <div style={{ padding: '0 7.1%', marginBottom: 20, maxWidth: 'calc(800px + 14.2%)', margin: '0 auto 20px' }}>
        <div style={{
          color: '#696969',
          fontFamily: 'helvetica, arial, sans-serif',
          fontSize: 20,
          fontWeight: 400,
          lineHeight: '1.4em'
        }}>
          Further reading &amp; map data sources:<br />
          <a href="https://www.epa.gov/great-lakes-aocs/rouge-river-aoc" target="_blank" rel="noopener noreferrer" style={{ color: '#1769FF' }}>https://www.epa.gov/great-lakes-aocs/rouge-river-aoc</a><br />
          <a href="https://www.detroitnews.com/story/news/local/wayne-county/2018/05/19/rouge-river-cleanup-efforts/35099307/" target="_blank" rel="noopener noreferrer" style={{ color: '#1769FF' }}>https://www.detroitnews.com/story/news/local/wayne-county/2018/05/19/rouge-river-cleanup-efforts/35099307/</a>
        </div>
      </div>

      {/* Detroit 360 panorama */}
      <div style={{ marginBottom: 4 }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://renderstuff.com/tools/360-panorama-web-viewer-embed/?image=https://i.imgur.com/II9zq9H.jpeg"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            allowFullScreen
            title="Detroit 360 Panorama" />
          
        </div>
      </div>

      {/* Interactive 360/VR Short caption */}
      <div style={{ padding: '0 7.1%', marginBottom: 20, maxWidth: 'calc(800px + 14.2%)', margin: '0 auto 20px' }}>
        <div style={{
          color: '#696969',
          fontFamily: 'helvetica, arial, sans-serif',
          fontSize: 20,
          fontWeight: 400,
          lineHeight: '1.4em',
          textAlign: 'center'
        }}>
          Interactive 360/VR Short
        </div>
      </div>

      {/* ── DETROIT GLYPHS GALLERY (from gallery 95320869) ── */}
      {/* Row 1: full width */}
      <div style={{ marginBottom: 4 }}>
        <GlyphImage
          src={DETROIT_IMAGES_KNOWN?.[0]}
          alt="Detroit River Rouge glyph — industrial corridor render"
          caption="Detroit Glyph I — River Rouge Corridor"
          location="River Rouge, MI (48217)"
          year="2020" />
        
      </div>

      {/* Detroit 360 panorama 2 */}
      <div style={{ marginBottom: 4 }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://renderstuff.com/tools/360-panorama-web-viewer-embed/?image=https://i.imgur.com/OSh64kY.jpeg"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            allowFullScreen
            title="Detroit 360 Panorama 2" />
          
        </div>
      </div>

      {/* Interactive 360/VR Short caption 2 */}
      <div style={{ padding: '0 7.1%', marginBottom: 20, maxWidth: 'calc(800px + 14.2%)', margin: '0 auto 20px' }}>
        <div style={{
          color: '#1d1d1d',
          fontFamily: 'helvetica, arial, sans-serif',
          fontSize: 25,
          fontWeight: 400,
          lineHeight: '1.4em',
          textAlign: 'center'
        }}>
          Interactive 360/VR Short<br /><br />
          Click + Drag - Look Around
        </div>
      </div>

      {/* Row 2: full width */}
      <div style={{ marginBottom: 4 }}>
        <GlyphImage
          src={DETROIT_IMAGES_KNOWN?.[1]}
          alt="Detroit glyph — extruded street vectors, dark environment render"
          caption="Detroit Glyph II — Extruded Vectors"
          location="Detroit, MI"
          year="2020" />
        
      </div>

      {/* Detroit YouTube video */}
      <div style={{ marginBottom: 4 }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://www.youtube.com/embed/PSwYyvJB6to"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            allowFullScreen
            title="Detroit VR Short" />
          
        </div>
      </div>

      {/* Detroit 360 panorama 3 */}
      <div style={{ marginBottom: 4 }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://renderstuff.com/tools/360-panorama-web-viewer-embed/?image=https://i.imgur.com/ccPOf01.jpeg"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            allowFullScreen
            title="Detroit 360 Panorama 3" />
          
        </div>
      </div>

      {/* Detroit YouTube video 2 */}
      <div style={{ marginBottom: 20 }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://www.youtube.com/embed/UpcapX5Em9Q"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            allowFullScreen
            title="Detroit VR Short 2" />
          
        </div>
      </div>

      {/* ── CHICAGO | SOUTH/WEST SIDES ── */}
      <div style={{ padding: '0 7.1%', marginBottom: 20 }}>
        <div style={{ textAlign: 'center' }}>
          <span style={{
            color: '#696969',
            fontFamily: 'helvetica, arial, sans-serif',
            fontSize: 24,
            fontWeight: 400,
            fontStyle: 'italic'
          }}>Chicago | South/West Sides</span>
        </div>
      </div>

      {/* Chicago map */}
      <div style={{ marginBottom: 20 }}>
        <img src={CHICAGO_MAP} alt="Chicago South/West Sides map — 25 most polluted wards overlay" style={{ width: '100%', display: 'block' }} />
      </div>

      {/* Chicago description */}
      <div style={{ padding: '0 7.1%', marginBottom: 20, maxWidth: 'calc(800px + 14.2%)', margin: '0 auto 20px' }}>
        <div style={{
          color: '#696969',
          fontFamily: 'helvetica, arial, sans-serif',
          fontSize: 15,
          fontWeight: 400,
          lineHeight: '1.4em'
        }}>
          East Chicago/Indiana. The 25 most polluted wards of the city are all located in the city&apos;s south and west sides adjacent to communities of color, the map of Cook County pictured highlights these wards over a partially rehabilitated industrial dump site and abandoned steel factory plot, a few blocks from neighboring communities.
        </div>
      </div>

      {/* Chicago further reading */}
      <div style={{ padding: '0 7.1%', marginBottom: 20, maxWidth: 'calc(800px + 14.2%)', margin: '0 auto 20px' }}>
        <div style={{
          color: '#696969',
          fontFamily: 'helvetica, arial, sans-serif',
          fontSize: 18,
          fontWeight: 400,
          lineHeight: '1.4em'
        }}>
          Further Reading/Sources:<br />
          <a href="https://www.bettergov.org/news/interactive-map-pollution-hits-chicagos-west-south-sides-hardest/" target="_blank" rel="noopener noreferrer" style={{ color: '#1769FF' }}>https://www.bettergov.org/news/interactive-map-pollution-hits-chicagos-west-south-sides-hardest/</a><br />
          <a href="https://psmag.com/environment/which-chicago-neighborhoods-are-most-at-risk-from-pollution" target="_blank" rel="noopener noreferrer" style={{ color: '#1769FF' }}>https://psmag.com/environment/which-chicago-neighborhoods-are-most-at-risk-from-pollution</a><br />
          <a href="http://www.radicalcartography.net/index.html?chicagodots" target="_blank" rel="noopener noreferrer" style={{ color: '#1769FF' }}>http://www.radicalcartography.net/index.html?chicagodots</a>
        </div>
      </div>

      {/* Chicago 360 panorama */}
      <div style={{ marginBottom: 20 }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://renderstuff.com/tools/360-panorama-web-viewer-embed/?image=https://i.imgur.com/DcBSUfF.jpeg"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            allowFullScreen
            title="Chicago 360 Panorama" />
          
        </div>
      </div>

      {/* Continuation of New Nature */}
      <div style={{ padding: '0 7.1%', marginBottom: 20 }}>
        <div style={{ textAlign: 'center' }}>
          <span style={{
            color: '#696969',
            fontFamily: 'helvetica, arial, sans-serif',
            fontSize: 20,
            fontWeight: 400
          }}>Continuation of <a href="https://www.behance.net/gallery/87302213/A-New-Nature-East-ChicagoIndiana" target="_blank" rel="noopener noreferrer" style={{ color: '#1769FF' }}>New Nature</a></span>
        </div>
      </div>

      {/* Chicago 360 panorama 2 */}
      <div style={{ marginBottom: 20 }}>
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
          <iframe
            src="https://renderstuff.com/tools/360-panorama-web-viewer-embed/?image=https://i.imgur.com/XQAPiJQ.jpeg"
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
            allowFullScreen
            title="Chicago 360 Panorama 2" />
          
        </div>
      </div>

      {/* In Progress: Game/Platform Design Concepts */}
      <div style={{ padding: '0 7.1%', marginBottom: 20 }}>
        <div style={{ textAlign: 'center' }}>
          <span style={{
            color: '#696969',
            fontFamily: 'helvetica, arial, sans-serif',
            fontSize: 20,
            fontWeight: 400
          }}>( In Progress: Game/Platform Design Concepts )</span>
        </div>
      </div>

      {/* Chicago game concepts image */}
      <div style={{ marginBottom: 20 }}>
        <img src={CHICAGO_GAME_CONCEPTS} alt="Chicago Game/Platform Design Concepts — in progress" style={{ width: '100%', display: 'block' }} />
      </div>
    </section>);

}